import type { InternalCrmDemoSalesReleaseFlags } from './internal-crm-demo-sales-release.config';

/**
 * Local/dev/staging admin overrides — enable demo platform + internal CRM surfaces.
 * Safety flags stay at buildReleaseFlags defaults (true). Production env must not spread this.
 */
export const DEV_DEMO_RELEASE_OVERRIDES: Partial<InternalCrmDemoSalesReleaseFlags> = {
  demoTenantsEnabled: true,
  demoProvisioningEnabled: true,
  demoLifecycleEnabled: true,
  demoLaunchEnabled: true,
  demoSeedingEnabled: true,
  demoToursEnabled: true,
  demoPacksEnabled: true,
  externalDemoAccessEnabled: true,
  demoAnalyticsEnabled: true,
  demoOperationsEnabled: true,
  demoConversionEnabled: true,
  internalCrmEnabled: true,
  demoCrmLinkingEnabled: true,
  demoCrmAutomationEnabled: true,
  crmCommandCenterEnabled: true,
  crmPlaybooksEnabled: true,
  crmFollowUpDraftsEnabled: true,
  crmDataQualityEnabled: true,
  crmAuditViewerEnabled: true,
  testTenantsEnabled: true,
  testProvisioningEnabled: true,
  testSeedingEnabled: true,
};
